import { createFileRoute, Outlet } from '@tanstack/react-router'

import { NotFoundPage } from '@/shared/components/common/NotFoundPage'

export const Route = createFileRoute('/_app/p')({
	component: () => <Outlet />,
	notFoundComponent: () => <NotFoundPage />,
})
